import {__} from "~/ts/library/Translate";
import OperatorApplicationPlatformInterface
    from "~/operatorApplication/ts/platform/OperatorApplicationPlatformInterface";
import {reactive, ref} from "vue";

export type LatestOperatorApplicationVersion = { version: string, electronVersion: string };

export default abstract class AbstractPlatformUpdater {
    public static applyUpdateFunction = ref<() => void>();

    //private updateReady: boolean = false;
    //private updateDownloading: boolean = false;
    private platform: OperatorApplicationPlatformInterface;

    private reactiveStorage: {
        updateReady: boolean;
        updateDownloading: boolean;
    } = null;

    constructor(platform: OperatorApplicationPlatformInterface) {
        this.reactiveStorage = reactive({
            updateReady: false,
            updateDownloading: false
        });
        this.platform = platform;
    }

    protected abstract getLatestVersion(): Promise<LatestOperatorApplicationVersion>;

    public abstract getCurrentApplicationVersion(): Promise<string>;

    protected abstract getUpdateArchiveUrl(latestVersion: LatestOperatorApplicationVersion): Promise<string>;

    public abstract make(): Promise<void>;

    public async checkAndFetchUpdate() {
        try {
            let newVersion = await this.checkForUpdates();
            if (newVersion) {
                this.fetchUpdate(newVersion);
            }
        } catch (e) {

        }
    }

    public async checkForUpdates(): Promise<LatestOperatorApplicationVersion> {
        try {
            let latestVersion = await this.getLatestVersion();
            let currentVersion = await this.getCurrentApplicationVersion();

            if (this.versionToInt(latestVersion.version) > this.versionToInt(currentVersion)) {
                return latestVersion;
            }
        } catch (e) {
            console.log("error", e);
        }
        return null;
    }

    public async fetchUpdate(version: LatestOperatorApplicationVersion) {
        this.reactiveStorage.updateDownloading = true;
        let url = await this.getUpdateArchiveUrl(version);
        try {
            if (await this.downloadUpdateToApplicationRoot(url)) {
                this.reactiveStorage.updateReady = true;
                AbstractPlatformUpdater.applyUpdateFunction.value = () => {
                    this.platform.exit();
                };

                this.platform.notifications.show({
                    title: __("Загружено обновление %s", version.version),
                    groupId: "readyToUpdate",
                    text: __("Готова к установке новая версия программы. Кликните сюда, чтобы обновиться прямо сейчас."),
                    click: AbstractPlatformUpdater.applyUpdateFunction.value
                });
            }
        } catch (e) {

        }
        this.reactiveStorage.updateDownloading = false;
    }

    protected abstract downloadUpdateToApplicationRoot(url: string): Promise<boolean>;

    private versionToInt(version: string): number {
        let result = 0;
        let versionArray = version.split(".");
        if (versionArray[0]) {
            result += parseInt(versionArray[0]) * 10000000000;
        }
        if (versionArray[1]) {
            result += parseInt(versionArray[1]) * 100000;
        }
        if (versionArray[2]) {
            result += parseInt(versionArray[2]);
        }
        return result;
    }

    get isReadyToUpdate(): boolean {
        return this.reactiveStorage.updateReady;
    }

    get isUpdatedDownloading(): boolean {
        return this.reactiveStorage.updateDownloading;
    }
}